module.exports = __webpack_public_path__ + "img/constrained.f8aa553b.jpeg";